// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formTable__row[data-v-04214440] {\n  display: table-row;\n}", ""]);
// Exports
module.exports = exports;
